<template>
    <div class="incoming-tariff-wrap">
        <div style="justify-content: space-between; display: flex">
            <div class="leader-radio">
                <el-radio-group
                    v-model="selectAccount"
                    v-for="item in accounts"
                    :key="item.elec_customer_account_id"
                    @change="toggleTab(item.elec_customer_account_id)"
                    size="medium"
                >
                    <el-radio-button
                        :label="item.account_name"
                        style="margin-right: 10px"
                    ></el-radio-button>
                </el-radio-group>
            </div>

            <div class="incoming-card-btn">
                <el-form
                    :inline="true"
                    :model="searchForm"
                    ref="searchForm"
                    :rules="searchFormRule"
                    class="leader-style-form"
                >
                    <el-form-item prop="selectDate" class="timePicker">
                        <el-date-picker
                            :picker-options="pickerDisabled"
                            v-model="searchForm.selectDate"
                            type="month"
                            placeholder="请选择时间"
                            :default-value="selectDate"
                            value-format="yyyy-MM"
                            format="yyyy-MM"
                            @change="yymm"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            icon="el-icon-caret-left"
                            @click="frontMonthClick"
                            size="medium"
                            class="time_btn"
                            >上一月</el-button
                        >
                        <el-button
                            @click="nextMonthClick"
                            :disabled="
                                this.sysDate === this.searchForm.selectDate
                            "
                            size="medium"
                            class="time_btn"
                        >
                            下一月
                            <i class="el-icon-caret-right"></i>
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            @click="search"
                            style="float:right;"
                            type="warning"
                            size="medium"
                            >查询</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-scrollbar style="height: 90%">
            <div class="echart-container">
                <div
                    style="text-align: left; font-size: 16px; border-left:5px solid #56fcff; color: #fff; padding-left: 10px;margin-top: 20px"
                >
                    月度电费趋势图
                </div>
                <div style="text-align: right; margin-bottom: 10px">
                    <el-button
                        class="leader-common-button"
                        @click="showYearChart('chart')"
                        >图表</el-button
                    >
                    <el-button
                        class="leader-common-button"
                        @click="showYearChart('table')"
                        >数据</el-button
                    >
                    <!-- <el-button
                        class="leader-common-button"
                        @click="exportMonthPowerAndCost"
                        >导出</el-button
                    > -->
                </div>
                <v-chart
                    :auto-resize="true"
                    :options="barYear"
                    ref="barYear"
                    theme="ovilia-green"
                    v-if="showYearCharts"
                    @click="clickYearBar"
                />
                <common-table
                    :tableData="tableYearData"
                    :columns="colsYear"
                    v-else
                ></common-table>

                <template v-if="showMonth">
                    <div
                        style="text-align: left; font-size: 16px; border-left:5px solid #56fcff; color: #fff; padding-left: 10px; margin-top: 20px"
                    >
                        {{ yearMonth }}电费
                    </div>

                    <div style="text-align: right; margin-bottom: 10px">
                        <el-button
                            class="leader-common-button"
                            @click="showMonthChart('chart')"
                            >图表</el-button
                        >
                        <el-button
                            class="leader-common-button"
                            @click="showMonthChart('table')"
                            >数据</el-button
                        >
                        <!-- <el-button
                            class="leader-common-button"
                            @click="exportDayPowerAndCost"
                            >导出</el-button
                        > -->
                    </div>
                    <v-chart
                        :auto-resize="true"
                        :options="barMonth"
                        ref="barMonth"
                        theme="ovilia-green"
                        v-if="showMonthCharts"
                        @click="clickMonthBar"
                    />
                    <common-table
                        :tableData="tableMonthData"
                        :columns="colsMonth"
                        v-else
                    ></common-table>
                </template>

                <template v-if="showDay">
                    <div
                        style="text-align: left; font-size: 16px; border-left:5px solid #56fcff; color: #fff; padding-left: 10px;margin-top: 20px"
                    >
                        {{ monthDay }}电费
                    </div>
                    <div style="text-align: right; margin-bottom: 10px">
                        <el-button
                            class="leader-common-button"
                            @click="showDayChart('chart')"
                            >图表</el-button
                        >
                        <el-button
                            class="leader-common-button"
                            @click="showDayChart('table')"
                            >数据</el-button
                        >
                        <!-- <el-button
                            class="leader-common-button"
                            @click="exportHourPowerAndCost"
                            >导出</el-button
                        > -->
                    </div>
                    <v-chart
                        :auto-resize="true"
                        :options="barDay"
                        ref="barDay"
                        theme="ovilia-green"
                        v-if="showDayCharts"
                    />
                    <common-table
                        :tableData="tableDayData"
                        :columns="colsDay"
                        v-else
                    ></common-table>
                </template>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import CommonTable from "@/comon/components/common-table.vue";
import * as api from "@/http/hr";
import { getAccounts, getSysDate } from "@/http/api";
import moment from "moment";
import utils from "@/utils/utils";
export default {
    components: { CommonTable },
    props: {
        date: {
            type: String,
            required: true
        },
        account_id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            selectAccount: "", //选择的户号
            selectAccountId: "", //选择的户号id
            accounts: [], //户号列表
            sysDate: "", //系统时间
            searchForm: {
                selectDate: "" //选择的时间
            },
            pickerDisabled: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysDate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            searchFormRule: {
                selectDate: [
                    {
                        required: true,
                        message: "时间不能为空",
                        trigger: "change"
                    }
                ]
            },

            //年月图表------------start-----
            showYearCharts: true, //是否显示年月图表
            tableYearData: [], //年月图表数据
            colsYear: [
                { prop: "date", label: "日期" },
                { prop: "sharp", label: "尖时刻" },
                { prop: "peak", label: "峰时刻" },
                { prop: "off", label: "平时刻" },
                { prop: "shoulder", label: "谷时刻" }
            ],
            xAxisYear: [],
            yAxisYearSharp: [], // 年尖时刻
            yAxisYearPeak: [], // 年峰时刻
            yAxisYearOff: [], // 年平时刻
            yAxisYearShoulder: [], // 年谷时刻
            yAxisYearTotal: [],

            //年月图表------------end-----
            //月日图表------------start-----
            showMonth: false, //是否显示月日图表
            showMonthCharts: false, //是否显示月日图表
            yearMonth: "", //年月
            tableMonthData: [], //月日图表数据
            colsMonth: [
                { prop: "date", label: "日期" },
                { prop: "sharp", label: "尖时刻" },
                { prop: "peak", label: "峰时刻" },
                { prop: "off", label: "平时刻" },
                { prop: "shoulder", label: "谷时刻" }
            ],
            xAxisMonth: [],
            yAxisMonthSharp: [], // 年尖时刻
            yAxisMonthPeak: [], // 年峰时刻
            yAxisMonthOff: [], // 年平时刻
            yAxisMonthShoulder: [], // 年谷时刻
            yAxisMonthTotal: [],
            //月日图表------------end-----
            //日时图表------------end-----
            showDay: false, //是否显示小时图表
            showDayCharts: false, //是否显示月日图表
            monthDay: "", //月
            tableDayData: [], //日图表数据
            colsDay: [
                { prop: "date", label: "日期" },
                { prop: "sharp", label: "尖时刻" },
                { prop: "peak", label: "峰时刻" },
                { prop: "off", label: "平时刻" },
                { prop: "shoulder", label: "谷时刻" }
            ],
            xAxisDay: [],
            yAxisDaySharp: [], // 年尖时刻
            yAxisDayPeak: [], // 年峰时刻
            yAxisDayOff: [], // 年平时刻
            yAxisDayShoulder: [], // 年谷时刻
            yAxisDaysTotal: []
            //日时图表------------start-----
        };
    },
    created() {
        // 获取系统时间
        this.getSysDate();
    },
    methods: {
        // 获取户号列表
        getAccounts() {
            getAccounts().then(res => {
                if (res && res.error_code === "0") {
                    this.accounts = res.bus_json;
                    this.selectAccount = res.bus_json[0].account_name;
                    this.selectAccountId =
                        res.bus_json[0].elec_customer_account_id;
                    this.getMonthPowerAndCost();
                }
            });
        },
        // 获取系统时间
        getSysDate() {
            getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.selectDate = res.bus_json.sysdate3;
                    this.sysDate = res.bus_json.sysdate3;

                    // 获取户号
                    this.getAccounts();
                }
            });
        },
        // 上一月
        frontMonthClick() {
            const now = moment(this.searchForm.selectDate);
            this.searchForm.selectDate = now
                .subtract(1, "months")
                .format("YYYY-MM");
            this.getMonthPowerAndCost();
        },
        //下一月
        nextMonthClick() {
            const now = moment(this.searchForm.selectDate);
            this.searchForm.selectDate = now.add(1, "months").format("YYYY-MM");
            this.getMonthPowerAndCost();
        },
        // 查询
        search() {
            this.$refs["searchForm"].validate(valid => {
                if (valid) {
                    this.getMonthPowerAndCost();
                }
            });
        },

        // 获取一年的目录电量
        getMonthPowerAndCost() {
            api.getMonthPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.searchForm.selectDate
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxisYear = res.bus_json.x_list;
                    this.yAxisYearSharp = res.bus_json.sharp_cost_list;
                    this.yAxisYearPeak = res.bus_json.peak_cost_list;
                    this.yAxisYearOff = res.bus_json.off_cost_list;
                    this.yAxisYearShoulder = res.bus_json.shoulder_cost_list;
                    this.yAxisYearTotal = res.bus_json.total_cost_list;
                }
            });
        },
        exportMonthPowerAndCost() {
            api.exportMonthPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.searchForm.selectDate,
                type: 2
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = "目录电费" + ".xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        // 年图表数据转换
        showYearChart(type) {
            this.tableYearData = [];
            for (let i = 0; i < this.xAxisYear.length; i++) {
                let obj = {};
                obj.date = this.xAxisYear[i];
                obj.sharp = this.yAxisYearSharp[i];
                obj.peak = this.yAxisYearPeak[i];
                obj.off = this.yAxisYearOff[i];
                obj.shoulder = this.yAxisYearShoulder[i];
                this.tableYearData.push(obj);
            }

            if (type === "chart") {
                this.showYearCharts = true;
            } else {
                this.showYearCharts = false;
            }
        },
        //年柱状图点击事件
        clickYearBar(params) {
            this.yearMonth = params.name;
            this.showMonth = true;
            this.showMonthCharts = true;
            this.getDayPowerAndCost(this.yearMonth);
        },
        // 获取月度数据
        getDayPowerAndCost(date) {
            api.getDayPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_month: date
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxisMonth = res.bus_json.x_list;
                    this.yAxisMonthSharp = res.bus_json.sharp_cost_list;
                    this.yAxisMonthPeak = res.bus_json.peak_cost_list;
                    this.yAxisMonthOff = res.bus_json.off_cost_list;
                    this.yAxisMonthShoulder = res.bus_json.shoulder_cost_list;
                    this.yAxisMonthTotal = res.bus_json.total_cost_list;
                }
            });
        },
        exportDayPowerAndCost() {
            api.exportDayPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.yearMonth,
                type: 2
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = this.yearMonth + "目录电费" + ".xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        // 月图表数据转换
        showMonthChart(type) {
            this.tableMonthData = [];
            for (let i = 0; i < this.xAxisMonth.length; i++) {
                let obj = {};
                obj.date = this.xAxisMonth[i];
                obj.sharp = this.yAxisMonthSharp[i];
                obj.peak = this.yAxisMonthPeak[i];
                obj.off = this.yAxisMonthOff[i];
                obj.shoulder = this.yAxisMonthShoulder[i];
                this.tableMonthData.push(obj);
            }

            if (type === "chart") {
                this.showMonthCharts = true;
            } else {
                this.showMonthCharts = false;
            }
        },
        clickMonthBar(params) {
            this.monthDay = params.name;
            this.showDay = true;
            this.showDayCharts = true;
            this.getHourPowerAndCost(this.monthDay);
        },
        // 获取小时数据
        getHourPowerAndCost(date) {
            api.getHourPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_day: date
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxisDay = res.bus_json.x_list;
                    this.yAxisDaySharp = res.bus_json.sharp_cost_list;
                    this.yAxisDayPeak = res.bus_json.peak_cost_list;
                    this.yAxisDayOff = res.bus_json.off_cost_list;
                    this.yAxisDayShoulder = res.bus_json.shoulder_cost_list;
                    this.yAxisDaysTotal = res.bus_json.total_cost_list;
                }
            });
        },
        exportHourPowerAndCost() {
            api.exportHourPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_day: this.monthDay,
                type: 2
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = this.monthDay + "目录电费" + ".xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        // 小时图表数据转换
        showDayChart(type) {
            this.tableDayData = [];
            for (let i = 0; i < this.xAxisDay.length; i++) {
                let obj = {};
                obj.date = this.xAxisDay[i];
                obj.sharp = this.yAxisDaySharp[i];
                obj.peak = this.yAxisDayPeak[i];
                obj.off = this.yAxisDayOff[i];
                obj.shoulder = this.yAxisDayShoulder[i];
                this.tableDayData.push(obj);
            }

            if (type === "chart") {
                this.showDayCharts = true;
            } else {
                this.showDayCharts = false;
            }
        },
        toggleTab(val) {
            this.selectAccountId = val;
            this.getMonthPowerAndCost();
        }
    },
    computed: {
        barYear() {
            const options = {
                grid: {
                    left: "1%",
                    right: "2%",
                    bottom: "5%",
                    top: "10%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["尖电费", "峰电费", "平电费", "谷电费"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#fe7f65", "#ffcb4f", "#0091e9", "#2ab85c", "#ffffff"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "月",
                        data: this.xAxisYear,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: 元",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "尖电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisYearSharp
                    },
                    {
                        name: "峰电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisYearPeak
                    },
                    {
                        name: "平电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisYearOff
                    },
                    {
                        name: "谷电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisYearShoulder
                    },
                    {
                        name: "总电费",
                        type: "line",
                        lineStyle: {
                            opacity: 0
                        },
                        label: {
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        data: this.yAxisYearTotal,
                        smooth: true,
                        symbol: "none"
                    }
                ]
            };
            return options;
        },
        barMonth() {
            const options = {
                grid: {
                    left: "1%",
                    right: "2%",
                    bottom: "5%",
                    top: "10%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["尖电费", "峰电费", "平电费", "谷电费"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#fe7f65", "#ffcb4f", "#0091e9", "#2ab85c", "#ffffff"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "日",
                        // axisLabel: {
                        //     rotate: -45,
                        // },
                        data: this.xAxisMonth,
                        axisLabel: {
                            rotate: -45,
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: 元",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "尖电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisMonthSharp
                    },
                    {
                        name: "峰电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisMonthPeak
                    },
                    {
                        name: "平电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisMonthOff
                    },
                    {
                        name: "谷电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisMonthShoulder
                    },
                    {
                        name: "总电费",
                        type: "line",
                        lineStyle: {
                            opacity: 0
                        },
                        label: {
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        smooth: true,
                        symbol: "none",
                        data: this.yAxisMonthTotal
                    }
                ]
            };
            return options;
        },
        barDay() {
            const options = {
                grid: {
                    left: "1%",
                    right: "2%",
                    bottom: "5%",
                    top: "10%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["尖电费", "峰电费", "平电费", "谷电费"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#fe7f65", "#ffcb4f", "#0091e9", "#2ab85c", "#ffffff"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "小时",
                        data: this.xAxisDay,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: 元",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "尖电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisDaySharp
                    },
                    {
                        name: "峰电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisDayPeak
                    },
                    {
                        name: "平电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisDayOff
                    },
                    {
                        name: "谷电费",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        data: this.yAxisDayShoulder
                    },
                    {
                        name: "总电费",
                        type: "line",
                        lineStyle: {
                            opacity: 0
                        },
                        label: {
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        smooth: true,
                        symbol: "none",
                        data: this.yAxisDaysTotal
                    }
                ]
            };
            return options;
        }
    }
};
</script>
<style lang="scss">
.incoming-tariff-wrap {
    width: 100%;
    height: 100%;
    padding: 0 px2Rem(40px);
    box-sizing: border-box;
    .echart-container {
        width: 100%;
        height: 100%;
        .echarts {
            width: 100%;
            height: px2Rem(320px);
        }
    }
}
</style>
